import { defaultColumns, defaultSort } from '../../components/reports/outstandings/columns';

export default {
  state: {
    outstandings: [],
    outstandingsByCountries: [],
    outstandingsByUsers: [],
    tableConfig: null,
    loading: false,
    countyLoading: false,
    userLoading: false,
    filterString: null,
    sorting: {
      prop: 'gross_price',
      order: 'desc',
    },
  },
  getters: {
    outstandings: state => state.outstandings,
    tableConfig: state => state.tableConfig,
    loading: state => state.loading,
    countyLoading: state => state.countyLoading,
    userLoading: state => state.userLoading,
    sorting: state => state.sorting,
    filterString: state => state.filterString,
    outstandingsByCountries: state => state.outstandingsByCountries,
    outstandingsByUsers: state => state.outstandingsByUsers,
  },
  mutations: {
    setOutstandingsByCountries(state, outstandings) {
      state.outstandingsByCountries = outstandings;
    },
    setOutstandingsByUsers(state, outstandings) {
      state.outstandingsByUsers = outstandings;
    },
    setOutstandings(state, outstandings) {
      state.outstandings = outstandings;
    },
    setTableConfig(state, config) {
      state.tableConfig = config;
    },
    setSorting(state, sorting) {
      state.sorting = sorting;
    },
    setFilterString(state, filter) {
      state.filterString = filter;
    },
    setLoading(state, loading) {
      state.loading = loading;
    },
    setCountyLoading(state, loading) {
      state.countyLoading = loading;
    },
    setUserLoading(state, loading) {
      state.userLoading = loading;
    },
  },
  actions: {
    async fetchTableConfig({ commit }) {
      try {
        const setting = await axios.get('api/table-settings/outstanding-list');
        const tableConfig = {
          id: setting.id || null,
          type: 'outstanding-list',
          columns: setting.id ? JSON.parse(setting.config).columns : defaultColumns,
          sort: setting.id ? JSON.parse(setting.config).sort : defaultSort,
        };
        commit('setTableConfig', tableConfig);
      } catch (e) {
      }
    },
    async fetchAll({ commit, state, dispatch }, queryString) {
      commit('setLoading', true);
      try {
        if (!state.tableConfig) {
          await dispatch('fetchTableConfig');
        }
        if (queryString) {
          commit('setFilterString', queryString.substr(1));
        } else if (queryString === '') {
          commit('setFilterString', '');
        } else {
          commit('setFilterString', state.filterString || '');
        }
        const query = `?sortby=${state.sorting.prop}&sorttype=${state.sorting.order === 'ascending' ? 'asc' : 'desc'}&${state.filterString}`;
        const outstandings = await axios.get('api/reports/outstandings' + (query || ''));
        commit('setOutstandings', outstandings);
      } catch (e) {
      }
      commit('setLoading', false);
    },

    async fetchByCounties({ commit, state, dispatch }, queryString = null) {
      commit('setCountyLoading', true);
      const outstandingsByCountries = await axios.get('api/reports/outstandings-by-countries' + (queryString || ''));
      commit('setOutstandingsByCountries', outstandingsByCountries);
      commit('setCountyLoading', false);
    },
    async fetchByUsers({ commit, state, dispatch }, queryString = null) {
      commit('setUserLoading', true);
      const outstandings = await axios.get('api/reports/outstandings-by-users' + (queryString || ''));
      commit('setOutstandingsByUsers', outstandings);
      commit('setUserLoading', false);
    }
  },
};
